export default [
  {
    path: '/app/zenno-stocks',
    name: 'ZennoStocks',
    component: () => import('@/views/Admin/Zenno_stocks/Index.vue'),
    meta: {
      pageTitle: 'Görsel Galerisi',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_ZENNO_STOCKS',
      action: 'read',
    },
  },
  {
    path: '/app/zenno-stocks/add',
    name: 'ZennoStocksAdd',
    component: () => import('@/views/Admin/Zenno_stocks/Add.vue'),
    meta: {
      pageTitle: 'Görsel Galerisi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/zenno-stocks',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_ZENNO_STOCKS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/zenno-stocks/edit/:id',
    name: 'ZennoStocksEdit',
    component: () => import('@/views/Admin/Zenno_stocks/Edit.vue'),
    meta: {
      pageTitle: 'Görsel Galerisi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/zenno-stocks',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_ZENNO_STOCKS_EDIT',
      action: 'read',
    },
  },
]
